import { afterNextRender, Component, computed, inject } from '@angular/core';

import { LangPipe, LangService } from '@reforgium/presentia';

import { AppVersionService } from './app-version.service';

@Component({
  selector: 'app-update-banner',
  imports: [LangPipe],
  template: `
    @if (versionService.updateAvailable()) {
      <section class="update-banner" role="status">
        <div>
          <strong>{{ 'common.updateAvailable' | lang }}</strong>
          @if (formattedBuiltAt(); as builtAt) {
            <span>{{ 'common.updateBuiltAt' | lang }}: {{ builtAt }}</span>
          }
        </div>
        <button type="button" (click)="reload()">{{ 'common.updateReload' | lang }}</button>
      </section>
    }
  `,
  styles: `
    .update-banner {
      position: fixed;
      right: 1.5rem;
      bottom: 1.5rem;
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 1rem;
      max-width: calc(100vw - 2rem);
      padding: 0.875rem 1rem;
      border-radius: 0.75rem;
      background: var(--primary-color);
      color: var(--surface-neutral);
      box-shadow: 0 12px 28px rgb(15 23 42 / 0.24);
    }

    .update-banner div {
      display: grid;
      gap: 0.2rem;
    }

    .update-banner strong {
      font-size: 0.9rem;
    }

    .update-banner span {
      font-size: 0.78rem;
      opacity: 0.9;
    }

    .update-banner button {
      padding: 0.5rem 0.75rem;
      border: 0;
      border-radius: 0.5rem;
      background: var(--surface-neutral);
      color: var(--primary-color);
      cursor: pointer;
      font: inherit;
      font-weight: 600;
    }

    @media (max-width: 640px) {
      .update-banner {
        right: 1rem;
        bottom: 1rem;
        left: 1rem;
        align-items: stretch;
        flex-direction: column;
      }
    }
  `,
})
export class UpdateBannerComponent {
  protected readonly versionService = inject(AppVersionService);
  private readonly langService = inject(LangService);

  protected readonly formattedBuiltAt = computed(() => {
    const builtAt = this.versionService.availableBuiltAt();
    const date = builtAt ? new Date(builtAt) : null;

    if (!date || Number.isNaN(date.getTime())) {
      return null;
    }

    return new Intl.DateTimeFormat(this.langService.currentLang() === 'ky' ? 'ky-KG' : 'ru-RU', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date);
  });

  constructor() {
    afterNextRender(() => this.versionService.start());
  }

  protected reload(): void {
    window.location.reload();
  }
}
